import { render, staticRenderFns } from "./VDonutChart.vue?vue&type=template&id=865f9f8a"
import script from "./VDonutChart.vue?vue&type=script&lang=js"
export * from "./VDonutChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports